import { PkIcon } from '@uefadigital/panenka-react';
import { memo } from 'react';

import { useTranslateFn } from '@shared/Translate';

const InfoVenueTime = () => {
  const t = useTranslateFn();

  return (
    <div className='pk-d--flex pk-align-items--center'>
      <PkIcon color='text-02' name='support-information' size={20} className='pk-mr--xs' />
      <span className='pk-font-size--s pk-font-size-md--m pk-text--text-02 pk-line-height--sm'>
        {t('ticketing_info_venue_time')}
      </span>
    </div>
  );
};

export default memo(InfoVenueTime);
